export default '1.11.15';



// WEBPACK FOOTER //
// ./src/lib/version.js